export const formatValueInPercentage = (key, value) => {
    if (typeof value !== 'number' || isNaN(value)) return value ?? '-';

    if (key.includes('percentage')) {
        return `${(value * 100).toFixed(2)}`;
    }

    return Number.isInteger(value) ? value : value.toFixed(2);
};
